import PubSub from 'pubsub-js'

const buildKey = (store, id) => {
  if (!id) id = '';
  return `${store.prefix}-${id}`;
}
const buildTopic = (store, id) => {
  if (!id) id = '';
  return `updated-${id}`;
}
const buildStore = (prefix, persist, defaultGen) => {
  return {
    prefix: prefix,
    persist: persist,
    getStorage: function() {
      return this.persist ? localStorage : sessionStorage
    },
    getKey: function(id) {
      return buildKey(this, id);
    },
    getTopic: function(id) {
      return buildTopic(this, id);
    },
    getDefault: defaultGen
  }
}
const defaultPattern = () => {
  return {
    layout: {
      type: 0,
      spaceX: 15,
      spaceY: 15
    },
    pattern: {
      type: 1,
      size: 50,
      border: 1
    },
    contrast: {
      type: 2,
      color1: '#000000',
      color2: '#ffffff'
    }
  }
}

const stores = {
  pattern: buildStore('pattern', false, defaultPattern),
  devices: buildStore('devices', false, () => { return [] })
}

class StorageService {
  get stores() { return stores }

  get(store, id) {
    let storage = store.getStorage();
    let storageKey = store.getKey(id);

    if (storage.getItem(storageKey) === null) {
      return this.reset(store, id);
    }
    
    return JSON.parse(storage.getItem(storageKey));
  }

  set(value, store, id) {
    let storage = store.getStorage();
    let storageKey = store.getKey(id);

    storage.setItem(storageKey, JSON.stringify(value));
    PubSub.publish(store.getTopic(id), value);
  }

  reset(store, id) {
    let defaultValue = store.getDefault();
    this.set(defaultValue, store, id);
    return defaultValue;
  }
}

export let storageService = new StorageService()


/** WEBPACK FOOTER **
 ** ./src/services/StorageService.js
 **/